import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { FileText, Download, X } from "lucide-react";

const apri = async (f) => {
  try { const r = await api.get(`/files/${f.id}/link`); window.open(`${process.env.REACT_APP_BACKEND_URL}${r.data.url}`, "_blank"); }
  catch (e) { toast.error(apiError(e)); }
};

export const CestinoFileModal = ({ origId, titolo, onClose }) => {
  const [files, setFiles] = useState(null);
  useEffect(() => { api.get(`/immobili-cestino-file/${origId}`).then((r) => setFiles(r.data)).catch((e) => { toast.error(apiError(e)); setFiles([]); }); }, [origId]);
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="cestino-file-modal">
      <div className="bg-white rounded-2xl w-full max-w-lg max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-[var(--border)]">
          <div className="font-semibold truncate">File conservati · {titolo}</div>
          <button data-testid="cestino-file-chiudi" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="overflow-y-auto p-2">
          {files === null && <div className="p-4 text-sm text-[var(--muted)]">Caricamento…</div>}
          {files && !files.length && <div className="p-4 text-sm text-[var(--muted)]" data-testid="cestino-file-vuoto">Nessun file.</div>}
          {(files || []).map((f) => (
            <button key={f.id} data-testid={`cestino-file-${f.id}`} onClick={() => apri(f)}
              className="w-full flex items-center gap-2 px-3 py-2 rounded-xl hover:bg-slate-50 text-left text-sm">
              <FileText size={14} className="shrink-0" /><span className="flex-1 truncate">{f.nome}</span>
              <span className="text-[11px] text-[var(--muted)]">{f.kind === "foto" ? "Foto" : "Documento"}</span><Download size={14} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export const FileConservati = () => {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);
  useEffect(() => { api.get("/immobili-file-conservati").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="mb-4 rounded-2xl border border-[var(--border)] p-3" data-testid="file-conservati">
      <div className="text-xs font-semibold mb-2">File conservati di immobili eliminati definitivamente</div>
      <div className="flex flex-wrap gap-2">
        {items.map((c) => (
          <button key={c.orig_id} data-testid={`file-conservati-${c.orig_id}`} onClick={() => setSel(c)}
            className="text-xs px-3 py-1.5 rounded-full bg-slate-100 hover:bg-slate-200">{c.titolo || c.indirizzo || "Immobile"} · {c.n_file} file</button>
        ))}
      </div>
      {sel && <CestinoFileModal origId={sel.orig_id} titolo={sel.titolo} onClose={() => setSel(null)} />}
    </div>
  );
};
